module.exports = {
    fetchData: async () => {
        const quickReleaseData = fetch('/get-quick-release-data')
            .then((response) => response.json())
            .catch((error) => {
                console.error(error);
            });

        return quickReleaseData;
    }
}
